<template>
  <DialogInfo
    v-bind:visible="visible"
    v-bind:title="title"
    @hidden="teamSelected"
  >
    <p class="mt-0" v-if="description.length > 0">{{ description }}</p>
    <p class="my-2">
      <b-form-select v-if="userTeams" v-model="activeTeam" autofocus>
        <option
          v-for="team in sortedTeamList"
          v-bind:key="team.id"
          v-bind:value="team"
          >{{ team.name }}</option
        >
      </b-form-select>
    </p>
  </DialogInfo>
</template>

<script>
import DialogInfo from "@/components/DialogInfo";
import { mapState } from "vuex";

export default {
  name: "DialogTeamSelect",
  components: {
    DialogInfo
  },
  model: {
    prop: "visible",
    event: "hidden"
  },
  props: {
    teams: {
      default: null
    },
    visible: {
      default: false
    },
    title: {
      default: "Choose your active team"
    },
    description: {
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("teamStore", {
      userTeams: "userTeams",
      activeTeam: "activeTeam"
    }),
    sortedTeamList() {
      var sortedTeams = this.$_.sortBy(this.userTeams, [
        team => team.name.toLowerCase()
      ]);
      return sortedTeams;
    }
  },
  methods: {
    teamSelected() {
      this.$emit("hidden", false);
      this.$emit("ok");
    }
  },
  created() {
    this.$store.dispatch("teamStore/loadUserTeams", this);
  },
  destroyed() {
    this.$topquiz.unsubscribe(this);
  }
};
</script>
